module.exports = __webpack_public_path__ + "static/img/content.bd36524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/content.png
// module id = /5qs
// module chunks = 1